//Module Keys
let locales = {};

//Merge Views
import mainView from 'Modules/fleet/views/main/lan/es';
import ModalScheduleStarter from 'Modules/fleet/components/ModalScheduleStarter/lan/es';
import ModalEnableDisable from 'Modules/fleet/components/ModalEnableDisable/lan/es';
//import ModalInputs from 'Modules/fleet/components/ModalInputs/lan/es';
import ModalPing from 'Modules/fleet/components/ModalPing/lan/es';
import ModalLandMark from 'Modules/fleet/components/ModalLandMark/lan/es';
import ModalOutputs from 'Modules/fleet/components/ModalOutputs/lan/es';
import ModalBulkOutputs from 'Modules/fleet/components/ModalBulkOutputs/lan/es';
import ModalExportColumnsPdf from 'Modules/fleet/components/modalExportColumnsPdf/lan/es';
import ModalUpdateUnit from 'Modules/fleet/components/ModalUpdateUnit/lan/es';
import ModalImportUnits from 'Modules/fleet/components/ModalImportUnits/lan/es';

locales = {
  ...locales,
  ...mainView,
  ...ModalScheduleStarter,
  ...ModalEnableDisable,
  //...ModalInputs, 
  ...ModalPing,
  ...ModalLandMark,
  ...ModalOutputs,
  ...ModalBulkOutputs,
  ...ModalExportColumnsPdf,
  ...ModalUpdateUnit,
  ...ModalImportUnits
};

export default locales;
